export { MorphemeTileGlyph } from "#morpheme-tile-glyph";
